// LanguageContext.js
import React, { createContext, useState } from "react";
import { useParams } from "react-router-dom";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const { lang } = useParams();
  const [language, setLanguage] = useState(lang || "es");

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
